import { useParams } from "react-router-dom";
import { useGetNotificacionesQuery } from "../services/docs";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/Acordion";
import { Spinner } from "../components/Spinner"; // Asegúrate de la ruta correcta
import { DataTable } from "./EjemploTabla";

// Definición de columnas para la tabla
const columns: any[] = [
  {
    accessorKey: "fi_etapa",
    header: "Etapa",
  },
  {
    accessorKey: "fi_movimiento",
    header: "Movimiento",
  },
  {
    accessorKey: "fc_notificacion",
    header: "Notificación",
  },
  {
    accessorKey: "fc_mensaje_notificacion",
    header: "Mensaje",
  },
  {
    accessorKey: "fd_fecha_envio",
    header: "Fecha Envío",
  },
];

export const AcordionNotificacionesComponent = () => {
  const { siniestro = "0", tramite_id = "0" } = useParams();

  const { data, isLoading } = useGetNotificacionesQuery({
    siniestro,
    tramite: tramite_id,
  });

  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center p-8">
        <Spinner />
      </div>
    );
  }

  const notificaciones = data?.notificacionesApp || [];

  return (
    <Accordion
      type="single"
      collapsible
      defaultValue="activos"
      className="w-full pt-3 rounded-xl border border-slate-200 bg-white shadow-sm mb-5"
    >
      <AccordionItem value="activos" className="border-b-0">

        {/* --- HEADER DEL ACORDEÓN --- */}
        <AccordionTrigger className="flex w-full items-center justify-between px-5 py-4 hover:bg-slate-50 hover:no-underline data-[state=open]:border-b data-[state=open]:border-slate-100">
          <div className="flex items-center gap-2">
            <div className="h-4 w-1.5 rounded bg-indigo-500"></div>
            <h3 className="flex items-center gap-2 text-sm font-bold text-slate-800">
              <svg className="h-4 w-4 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path></svg>
              Historial de Notificaciones APP
            </h3>
            <span className="font-mono text-xs font-normal text-slate-400">
              ({notificaciones.length} registros)
            </span>
          </div>
        </AccordionTrigger>

        {/* --- CONTENIDO DESPLEGABLE --- */}
        <AccordionContent className="px-5 py-6 text-sm">
          {notificaciones.length === 0 ? (

            /* Empty State */
            <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50/50 py-10 text-center">
              <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-indigo-50 text-indigo-300">
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"></path></svg>
              </div>
              <p className="text-sm font-bold text-slate-600">No hay notificaciones</p>
              <p className="mt-1 text-xs text-slate-400">El asegurado no ha recibido notificaciones a través de la aplicación móvil.</p>
            </div>

          ) : (

            /* Contenedor de la Tabla */
            <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
              <DataTable
                data={notificaciones}
                columns={columns}
                action={() => { }}
              />
            </div>

          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
